import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "1",
    title: "首尔雨夜",
    originalTitle: "Seoul Rainy Night",
    year: 2019,
    genres: ["爱情", "剧情"],
    rating: 8.2,
    duration: 102,
    director: "朴贤宇",
    cast: ["金智秀", "李在勋", "崔恩熙"],
    region: "韩国",
    collection: ["hot"],
    synopsis:
      "一场持续整夜的暴雨把两个陌生人的行程困在同一间旧式咖啡馆里。她是刚结束十年婚姻的调香师，他是准备离开首尔去釜山开小酒馆的录音师。窗外的雨声成了唯一的配乐，天亮之前，他们交换了各自人生里最难说出口的那一段。",
    analysis: [
      "影片几乎全部发生在雨夜与室内空间，导演用大量雨声与玻璃反光作为情绪留白，把两个成年人之间那种「知道自己不该开始、却舍不得结束」的犹疑拍得非常克制。全片没有一句直白的告白，所有靠近都发生在递杯子、关灯、以及雨声变小的间隙里。",
      "结构上是典型的双线叙事：一条是当下这场雨夜，一条是两人各自的回忆片段。回忆段落没有刻意做旧，而是用雨声的层次差来区分，观众需要靠人物语气判断时间，这种留白让第二次观看时的感受完全不同。",
      "值得肯定的是影片对成年人关系里的分寸感处理得相当体面，没有把亲密当作戏剧冲突的唯一出口，而是把重点放在两个人如何重新确认自己想要什么。这也是它在本站评分长期靠前的原因。",
    ],
    tags: ["暴雨夜", "成年人关系", "双线叙事", "咖啡馆"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20art-house%20film%20poster%20artwork%2C%20lone%20woman%20silhouette%20holding%20a%20transparent%20umbrella%20in%20a%20rain-soaked%20Seoul%20alley%20at%20night%2C%20deep%20crimson%20and%20amber%20neon%20reflections%20on%20wet%20asphalt%2C%20heavy%20atmosphere%20and%20mist%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20muted%20dark%20tones%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-01&orientation=portrait",
    views: 182400,
    comments: [
      { id: "1-1", user: "雨声收集者", date: "2025-03-11", text: "最后关灯那一段，什么都不用说。这种克制在同类题材里太少见了。", likes: 128 },
      { id: "1-2", user: "周五夜场", date: "2025-01-29", text: "画面调色很稳，雨夜的光反射做得特别好，全程没有出戏。", likes: 74 },
      { id: "1-3", user: "胶片边缘", date: "2024-11-06", text: "录音师这个职业设定很聪明，声音成了第三位主角。", likes: 61 },
    ],
  },
  {
    id: "2",
    title: "玫瑰公寓",
    originalTitle: "Rose Apartment",
    year: 2021,
    genres: ["都市", "悬疑"],
    rating: 7.8,
    duration: 96,
    director: "郑多恩",
    cast: ["韩素妍", "吴承贤", "李度允"],
    region: "韩国",
    collection: ["hot"],
    synopsis:
      "一栋建于八十年代末的老式公寓，七户人家共用一个狭窄的走廊。新搬来的插画师发现，每到凌晨两点，走廊尽头那扇门总会开一条缝。她开始记录邻居们的作息，也逐渐被这栋楼里所有人的秘密裹了进去。",
    analysis: [
      "这是本站讨论度最高的一部都市悬疑向作品。导演把空间的压迫感做到了极致：走廊、楼梯转角、猫眼视角，几乎每个镜头都在强调「你离别人太近了」。观众和主角一样，始终处于被窥视的位置。",
      "叙事上用了很聪明的错位手法，前半段让观众以为自己在解谜，后半段才揭示真正的谜面是「谁在记录谁」。片中反复出现的速写本是一个很好的视觉母题，每一页都对应一个住户的谎话。",
      "结尾的处理有争议，但不少影迷认为它恰恰捍卫了影片的立场：公寓从来不会给出答案，它只是把人堆在一起。",
    ],
    tags: ["老式公寓", "邻里关系", "窥视视角", "都市悬疑"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%2C%20narrow%20old%20apartment%20corridor%20at%20night%20with%20one%20door%20slightly%20ajar%20and%20warm%20amber%20light%20spilling%20out%2C%20deep%20crimson%20velvet%20tones%2C%20long%20dramatic%20shadows%2C%20dusty%20atmosphere%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-02&orientation=portrait",
    views: 156900,
    comments: [
      { id: "2-1", user: "走廊尽头", date: "2025-04-02", text: "速写本那段回看两遍才反应过来，编剧真的很有耐心。", likes: 96 },
      { id: "2-2", user: "凌晨两点", date: "2025-02-18", text: "氛围一流，但结尾还是希望多一点交代。", likes: 42 },
    ],
  },
  {
    id: "3",
    title: "午夜地铁",
    originalTitle: "Midnight Line",
    year: 2018,
    genres: ["悬疑", "剧情"],
    rating: 7.5,
    duration: 110,
    director: "姜泰植",
    cast: ["尹书静", "朴道允", "金娜英"],
    region: "韩国",
    collection: ["classic"],
    synopsis:
      "末班车驶过终点站却没有停下。车厢里只剩五个人，广播开始在报出他们各自从未告诉过别人的站名。随着列车在黑暗中不断前行，五个人的过去被一节一节地打开。",
    analysis: [
      "这是韩国小成本悬疑里非常典型的高概念作品：一个封闭空间，一组互不相识的人，一条永远不结束的线路。成本极低，但调度扎实，仅靠车厢灯光的变化就完成了整部片子的情绪起伏。",
      "剧本的巧思在于把「站名」当作叙事机关，每个人被念到的那一站都对应一段不愿回溯的往事。这种设计让影片有了很强的重看价值。",
      "遗憾的是中段节奏略拖，第五个人的故事和前四位相比分量不足，收尾稍显仓促。但整体仍是这个话题下绕不开的一部。",
    ],
    tags: ["末班车", "封闭空间", "高概念", "群像"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20film%20poster%20artwork%2C%20empty%20late-night%20subway%20car%20interior%20with%20flickering%20warm%20fluorescent%20light%2C%20a%20lone%20woman%20silhouette%20standing%20by%20the%20window%2C%20deep%20burgundy%20and%20amber%20color%20palette%2C%20long%20reflections%20on%20polished%20floor%2C%20film%20grain%2C%20moody%20cinematic%20photography%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-03&orientation=portrait",
    views: 132500,
    comments: [
      { id: "3-1", user: "末班车乘客", date: "2024-12-20", text: "车厢灯光一暗我就开始紧张，调度真的绝。", likes: 88 },
      { id: "3-2", user: "站台风", date: "2024-09-14", text: "第五个人的段落确实弱了点，但不影响整体观感。", likes: 33 },
    ],
  },
  {
    id: "4",
    title: "汉江之夏",
    originalTitle: "Summer on the Han",
    year: 2023,
    genres: ["爱情", "剧情"],
    rating: 8.0,
    duration: 108,
    director: "李周元",
    cast: ["徐敏智", "姜夏天", "崔宇镇"],
    region: "韩国",
    collection: ["hot", "new"],
    synopsis:
      "汉江边的一间旧自行车租赁店，暑假里来了一个只租不还的女孩。店主每天等她回来，等了一个夏天。多年后两人在江边再次相遇，才发现当年那句没说完的话，各自理解成了完全不同的意思。",
    analysis: [
      "影片把汉江拍成了一条时间轴：白天的江面明亮、拥挤，夜晚的江面安静得能听见水声。导演很少使用特写，多是把两个人放在画面的两端，用距离说话。",
      "这是本站评价最温和的一部作品，几乎没有冲突，靠大量生活细节堆叠情绪。租赁店的登记本、坏掉的车铃、冰柜里的汽水，都是很有效的记忆锚点。",
      "影片最打动人的地方在于它承认了错过：两个人并不是不够喜欢，只是当年都没有把话说明白。这种成年人的遗憾比任何激烈的戏剧冲突都更扎心。",
    ],
    tags: ["汉江", "夏日", "错过", "生活流"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20film%20poster%20artwork%2C%20two%20silhouettes%20riding%20bicycles%20along%20the%20Han%20River%20at%20golden%20summer%20sunset%2C%20warm%20amber%20and%20deep%20red%20sky%2C%20hazy%20backlight%2C%20soft%20lens%20flare%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-04&orientation=portrait",
    views: 174200,
    comments: [
      { id: "4-1", user: "江边散步", date: "2025-05-06", text: "登记本那个细节直接把我击穿了，太真实。", likes: 112 },
      { id: "4-2", user: "夏天很长", date: "2025-03-27", text: "没有狗血，没有误会，就是单纯地错过了，反而更难受。", likes: 90 },
    ],
  },
  {
    id: "5",
    title: "秘书的日记",
    originalTitle: "The Secretary's Diary",
    year: 2016,
    genres: ["都市", "剧情"],
    rating: 7.2,
    duration: 94,
    director: "金东赫",
    cast: ["文彩媛", "权时宇", "白承雅"],
    region: "韩国",
    collection: ["classic"],
    synopsis:
      "在公司待了七年的秘书，把所有不能说的话都写进了一本从不带回家的日记。当公司卷入一场审计风波，这本日记成了唯一能还原真相的证据，也成了她必须亲手交出去的东西。",
    analysis: [
      "影片前半段的职场细节非常扎实：谁先到办公室、谁负责给谁倒水、会议记录里被删掉的那一句。导演用这些琐碎建立了极强的真实感。",
      "中段转入调查线后节奏明显加快，办公室政治的层层推进是这部片子最好看的部分。它没有把秘书写成受害者，而是写成一个手里握着筹码、却很清楚代价的人。",
      "最后一幕交日记的处理干净利落，没有任何多余台词。这个结尾让整部片子的分量重了不少。",
    ],
    tags: ["职场", "办公室政治", "日记体", "女性视角"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20dim%20office%20desk%20at%20late%20night%20with%20an%20open%20leather%20diary%2C%20a%20glass%20of%20whisky%20and%20venetian%20blind%20shadows%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20volumetric%20dust%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-05&orientation=portrait",
    views: 98400,
    comments: [
      { id: "5-1", user: "格子间第七年", date: "2024-10-22", text: "职场部分写得太准了，看的时候一直在点头。", likes: 57 },
      { id: "5-2", user: "存档用", date: "2024-07-05", text: "结尾不加解释是加分项，克制住了。", likes: 39 },
    ],
  },
  {
    id: "6",
    title: "冷色调",
    originalTitle: "Cold Tone",
    year: 2020,
    genres: ["剧情", "悬疑"],
    rating: 8.4,
    duration: 118,
    director: "申允浩",
    cast: ["李知恩", "朴成勋", "郑在铉"],
    region: "韩国",
    collection: ["hot"],
    synopsis:
      "一位色彩修复师接到一卷受损的旧胶片，画面里出现了她自己童年住过的房子。随着修复进度推进，她发现这卷胶片的拍摄时间，比她记忆中那场火灾还要早三天。",
    analysis: [
      "本站评分最高的一部，也是讨论门槛最高的一部。影片把「修复」这件事本身当作叙事方法，修复进度条就是时间轴，图像越清晰，真相越难以承受。",
      "导演极擅长用色彩控制情绪，整部片子的饱和度被刻意压低，只有回忆片段保留了一点暖色。这种处理让观众始终处在一种冷静过头的状态里，与主角的职业身份高度统一。",
      "虽然结尾的解释略显刻意，但前两幕的氛围营造和表演水准都相当出色。尤其是修复室那场长镜，几乎可以单独拿出来当教学片段。",
    ],
    tags: ["胶片修复", "记忆", "低饱和", "高分佳作"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20film%20poster%20artwork%2C%20woman%20silhouette%20by%20a%20window%20with%20sheer%20curtain%20blowing%2C%20desaturated%20grey%20interior%20with%20a%20single%20warm%20amber%20rim%20light%2C%20deep%20crimson%20accent%2C%20heavy%20shadow%20contrast%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-06&orientation=portrait",
    views: 211600,
    comments: [
      { id: "6-1", user: "暗房里的猫", date: "2025-06-01", text: "修复室长镜我看了三遍，光是怎么打出来的啊。", likes: 156 },
      { id: "6-2", user: "低饱和", date: "2025-04-19", text: "结尾有点强行圆，但前两幕值回票价。", likes: 88 },
      { id: "6-3", user: "胶片爱好者", date: "2025-02-13", text: "把修复过程当叙事推进，这个点子太漂亮了。", likes: 71 },
    ],
  },
  {
    id: "7",
    title: "温泉旅馆",
    originalTitle: "Onsen Inn",
    year: 2017,
    genres: ["爱情", "剧情"],
    rating: 7.0,
    duration: 99,
    director: "崔炳国",
    cast: ["孙艺琳", "金武烈", "李承雅"],
    region: "韩国",
    collection: ["classic"],
    synopsis:
      "冬季淡季，一间只有六间客房的山中旅馆迎来一对没有预约的客人。老板娘说房间满了，却还是给他们留了最里面那一间。三天两夜里，三个人的过去慢慢浮出水面。",
    analysis: [
      "这是一部靠空间与季节撑起来的作品。雪、木廊、蒸汽、纸灯笼，导演把冬天的温度差拍得很有说服力，观众几乎能感觉到脚底的凉。",
      "剧本采用三人视角轮换，每个人掌握的信息都不完整。观众需要在对话之间自己拼出关系，这种参与感是它最迷人的地方。",
      "节奏偏慢，前四十分钟几乎没有事件发生，喜欢快节奏的观众可能会有点坐不住。但如果接受它的呼吸感，后半段的情绪回报很足。",
    ],
    tags: ["冬季", "山间旅馆", "三人视角", "慢节奏"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20winter%20film%20poster%20artwork%2C%20traditional%20Korean%20wooden%20inn%20veranda%20at%20dusk%20covered%20in%20snow%2C%20warm%20paper%20lanterns%20glowing%20amber%2C%20rising%20steam%20in%20cold%20air%2C%20deep%20crimson%20fabric%20accent%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20quiet%20melancholic%20mood%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-07&orientation=portrait",
    views: 87600,
    comments: [
      { id: "7-1", user: "雪天限定", date: "2024-12-02", text: "蒸汽和纸灯笼的光，冬天看真的会上瘾。", likes: 64 },
      { id: "7-2", user: "慢片爱好者", date: "2024-08-17", text: "前半段确实考验耐心，但结尾把三个人都收住了。", likes: 31 },
    ],
  },
  {
    id: "8",
    title: "霓虹出租车",
    originalTitle: "Neon Taxi",
    year: 2022,
    genres: ["都市", "爱情"],
    rating: 7.6,
    duration: 101,
    director: "朴贤宇",
    cast: ["郑柔美", "李在勋", "韩多顺"],
    region: "韩国",
    collection: ["hot"],
    synopsis:
      "一位只在深夜跑车的出租车司机，习惯把乘客的对话当作自己的睡前故事。直到某个下雨的凌晨，一位女乘客报出的地址，是他十年前没能回去的那条街。",
    analysis: [
      "整部影片几乎都在车内完成，后视镜是最重要的构图工具。导演用后视镜把「看见」和「被看见」的关系处理得很暧昧，观众始终不确定谁在观察谁。",
      "城市夜景的拍摄非常讲究，霓虹在车窗上的拉丝效果几乎没有依赖后期，是实拍完成的。这一点在影迷讨论里被反复提到。",
      "故事本身不算新鲜，但两位主演的克制表演救回了后半段的俗套。尤其是最后一段绕路，是全片的高光。",
    ],
    tags: ["深夜出租车", "城市夜景", "雨中", "绕路"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20film%20poster%20artwork%2C%20interior%20of%20a%20taxi%20at%20night%20seen%20from%20the%20back%20seat%2C%20blurred%20amber%20and%20crimson%20city%20lights%20through%20rainy%20window%2C%20driver%20silhouette%20and%20rearview%20mirror%2C%20fine%20film%20grain%2C%20moody%20cinematic%20photography%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-08&orientation=portrait",
    views: 143800,
    comments: [
      { id: "8-1", user: "凌晨三点半", date: "2025-05-21", text: "后视镜那几个构图真是绝，越看越有味。", likes: 79 },
      { id: "8-2", user: "夜班族", date: "2025-01-08", text: "最后绕的那一段，什么都不用解释，我都懂。", likes: 66 },
    ],
  },
  {
    id: "9",
    title: "红色高跟鞋",
    originalTitle: "Red Heels",
    year: 2015,
    genres: ["悬疑", "剧情"],
    rating: 8.6,
    duration: 112,
    director: "申允浩",
    cast: ["金惠珍", "柳承范", "朴敏书"],
    region: "韩国",
    collection: ["classic"],
    synopsis:
      "一栋老公寓的楼梯上，每隔三天就会出现一双红色高跟鞋。捡到它的女人一个接一个地失踪。当警察终于找到鞋的主人时，才发现她十年前就已经不住在这栋楼里了。",
    analysis: [
      "经典收藏区的常驻作品，也是很多人入门这类题材的第一部。影片把「物件」当作恐怖源，红色高跟鞋几乎不承担任何解释功能，它就是纯粹的视觉压迫。",
      "导演非常清楚什么时候该让观众看见，什么时候该让观众想象。片中大量使用画外音与空镜，成本不高，但氛围一流。",
      "故事逻辑上有些地方经不起推敲，但作为一部氛围向作品，它的完成度足以让人忽略这些瑕疵。十年来被反复模仿，却很少有作品能复刻它的质感。",
    ],
    tags: ["经典", "物件恐怖", "老公寓", "氛围流"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20noir%20film%20poster%20artwork%2C%20single%20red%20high%20heel%20shoe%20resting%20on%20a%20wet%20stone%20staircase%2C%20dramatic%20narrow%20spotlight%20from%20above%2C%20deep%20crimson%20color%20accent%2C%20black%20surroundings%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20eerie%20atmosphere%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-09&orientation=portrait",
    views: 268300,
    comments: [
      { id: "9-1", user: "老片重看", date: "2024-11-19", text: "十年前看的，现在重看还是会被楼梯那段吓到。", likes: 187 },
      { id: "9-2", user: "红鞋", date: "2024-06-30", text: "几乎没有血腥，但心理压力拉满，这才是本事。", likes: 143 },
    ],
  },
  {
    id: "10",
    title: "雾中列车",
    originalTitle: "Train in the Fog",
    year: 2014,
    genres: ["剧情", "悬疑"],
    rating: 8.1,
    duration: 124,
    director: "姜泰植",
    cast: ["文素利", "金义成", "尹书静"],
    region: "韩国",
    collection: ["classic"],
    synopsis:
      "一列开往东海岸的慢车因为大雾停在了半路。乘客被迫在车上过夜，而其中一个人，是二十年前那场事故里唯一没有找到遗体的人。",
    analysis: [
      "这是一部很难被归类的作品，既有悬疑的外壳，也有非常沉静的文学气质。全片大部分时间都在等雾散，而等待本身就是它的主题。",
      "群像调度是最大的亮点。车厢里的人各有各的行李，导演用极其简省的对话交代了每个人的来处，没有一句废笔。",
      "结尾没有给出明确答案，这一点在当年引发了不少争论。但十年过去，这种开放反而成了它被反复讨论的原因。",
    ],
    tags: ["大雾", "慢车", "群像", "开放结局"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20atmospheric%20film%20poster%20artwork%2C%20old%20train%20window%20covered%20in%20condensation%20with%20a%20silhouetted%20figure%20looking%20out%2C%20dense%20fog%20outside%2C%20muted%20sepia%20and%20deep%20burgundy%20tones%2C%20soft%20diffused%20light%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-10&orientation=portrait",
    views: 197400,
    comments: [
      { id: "10-1", user: "东海岸线", date: "2024-10-08", text: "等了十年还是觉得这部被低估了，群像写得太好。", likes: 121 },
      { id: "10-2", user: "雾天", date: "2024-05-12", text: "开放式结尾不是偷懒，是它唯一正确的收法。", likes: 84 },
    ],
  },
  {
    id: "11",
    title: "私语",
    originalTitle: "Whispers",
    year: 2024,
    genres: ["爱情", "剧情"],
    rating: 7.4,
    duration: 92,
    director: "郑多恩",
    cast: ["金智秀", "白承雅", "吴承贤"],
    region: "韩国",
    collection: ["new"],
    synopsis:
      "两个在同一栋写字楼里工作、却从没说过话的人，习惯在午休时躲进同一个消防楼梯间。他们从不交谈，只是各自待着。直到某天，其中一个人开始对着墙轻轻说话。",
    analysis: [
      "这是今年最安静的一部新片，全片台词加起来不到两百句。导演几乎完全依赖呼吸、脚步和消防门的开合声推进叙事。",
      "影片对「陪伴」的定义很有意思：两个人不需要认识，也可以成为彼此一天里最稳定的部分。这种设定在都市题材里很少被认真对待。",
      "时长不到一百分钟，结构干净，适合一个人深夜看。缺点也很明显，情绪的高点偏少，习惯强情节的观众可能会觉得平淡。",
    ],
    tags: ["新片", "消防楼梯", "沉默", "都市孤独"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20intimate%20film%20poster%20artwork%2C%20two%20figures%20standing%20close%20in%20a%20bare%20concrete%20stairwell%2C%20one%20silhouette%20whispering%2C%20warm%20amber%20light%20from%20a%20small%20high%20window%2C%20deep%20crimson%20shadow%20tones%2C%20soft%20haze%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-11&orientation=portrait",
    views: 62400,
    comments: [
      { id: "11-1", user: "午休时间", date: "2025-06-14", text: "看完之后特意去走了公司的消防楼梯，有点恍惚。", likes: 52 },
      { id: "11-2", user: "轻声", date: "2025-05-02", text: "台词少但不闷，声音设计很见功力。", likes: 37 },
    ],
  },
  {
    id: "12",
    title: "镜中之城",
    originalTitle: "City in the Mirror",
    year: 2023,
    genres: ["悬疑", "剧情"],
    rating: 8.3,
    duration: 115,
    director: "申允浩",
    cast: ["韩素妍", "朴成勋", "崔恩熙"],
    region: "韩国",
    collection: ["hot"],
    synopsis:
      "一间老式剧院的化妆间里装了七面镜子。新来的女演员发现，镜子里自己的动作，总比现实慢半拍。她开始怀疑，真正被照出来的那个人，才活在现实里。",
    analysis: [
      "视觉上极其讲究的一部作品。七面镜子构成了复杂的反射系统，几乎每个镜头都同时存在三个以上的「她」，观众需要主动判断哪一个是本体。",
      "影片的红色用得极其克制，全片只有化妆间的灯光是饱和的暗红，其余部分全部压成灰调。这种对比让空间本身具有了角色属性。",
      "剧本在后半段引入了一个关于剧场旧事的支线，把整部片子的格局从个人心理扩展到了行业记忆。这个处理让影片比同类作品更有厚度。",
    ],
    tags: ["镜像", "剧院", "身份", "心理悬疑"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20psychological%20film%20poster%20artwork%2C%20vintage%20theatre%20dressing%20room%20with%20multiple%20tall%20mirrors%20creating%20repeated%20reflections%20of%20a%20woman%20silhouette%2C%20deep%20crimson%20and%20amber%20stage%20lighting%2C%20rich%20shadows%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-12&orientation=portrait",
    views: 168700,
    comments: [
      { id: "12-1", user: "第三面镜子", date: "2025-04-27", text: "构图太讲究了，每一帧都能截图当海报。", likes: 132 },
      { id: "12-2", user: "剧场常客", date: "2025-02-04", text: "剧院旧事那条线加得很妙，格局一下就打开了。", likes: 77 },
    ],
  },
  {
    id: "13",
    title: "晚风告白",
    originalTitle: "Confession at Dusk",
    year: 2025,
    genres: ["爱情", "剧情"],
    rating: 7.9,
    duration: 97,
    director: "李周元",
    cast: ["徐敏智", "姜夏天", "郑柔美"],
    region: "韩国",
    collection: ["new"],
    synopsis:
      "搬家前最后一个晚上，她约他到天台，说要把一些东西还给他。行李箱里装的全是十年间他随手给的小物件。两个人坐在天台边上，从日落一直聊到路灯亮起。",
    analysis: [
      "今年的新片里完成度相当高的一部。全片只有一个主要场景，但靠着时间的推移和光线的变化，完全没有单调感。",
      "对白写得很好，两个人始终在聊一些无关紧要的事，真正想说的那句一直悬着。这种处理方式非常考验演员，两位主演接住了。",
      "结尾没有让任何一方妥协，也没有强行圆满，这点很难得。适合在夏末的晚上看，看完会想给某个人发条消息。",
    ],
    tags: ["新片", "天台", "十年", "单场景"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20film%20poster%20artwork%2C%20rooftop%20at%20dusk%20with%20two%20distant%20silhouettes%20sitting%20side%20by%20side%2C%20wind-blown%20hair%2C%20glowing%20orange%20and%20deep%20red%20sunset%20sky%2C%20city%20skyline%20in%20haze%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20warm%20nostalgic%20mood%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-13&orientation=portrait",
    views: 74100,
    comments: [
      { id: "13-1", user: "天台见", date: "2025-07-02", text: "看完真的给三年没联系的人发了消息，后劲很大。", likes: 98 },
      { id: "13-2", user: "夏末", date: "2025-06-21", text: "台词太好了，全程在聊废话但每句都有意思。", likes: 63 },
    ],
  },
  {
    id: "14",
    title: "梨泰院的夜",
    originalTitle: "Night in Itaewon",
    year: 2013,
    genres: ["都市", "剧情"],
    rating: 7.9,
    duration: 106,
    director: "金东赫",
    cast: ["金惠珍", "权时宇", "韩多顺"],
    region: "韩国",
    collection: ["classic"],
    synopsis:
      "一家开在梨泰院巷子里的酒吧，老板从不在白天出现。四个常客各怀心事，在一个停电的夜里，把所有不该说的话都说完了。",
    analysis: [
      "十多年前的片子，现在看依然不过时。导演拍出了那个街区特有的混乱与包容，街头的霓虹、英文招牌、混在人群里的陌生人，都是很珍贵的时代记录。",
      "剧本结构接近舞台剧，四个常客加一个老板，全片几乎都在吧台前完成。停电那场戏是全片的转折，也是调度最精彩的部分。",
      "作为经典收藏区的常客，它的价值不止在故事，更在于它保存了一个已经消失的街区氛围。",
    ],
    tags: ["经典", "梨泰院", "酒吧", "停电夜"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20night%20film%20poster%20artwork%2C%20narrow%20Seoul%20backstreet%20bar%20entrance%20at%20night%20with%20warm%20string%20lights%20and%20blurred%20crowd%20bokeh%2C%20deep%20crimson%20and%20amber%20neon%20glow%2C%20rainy%20pavement%20reflections%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-14&orientation=portrait",
    views: 152300,
    comments: [
      { id: "14-1", user: "老街区", date: "2024-09-25", text: "现在再看，那条街已经变了大半，这部片子太珍贵了。", likes: 104 },
      { id: "14-2", user: "停电夜", date: "2024-04-16", text: "舞台剧式的调度，五个人一台戏，一点都不闷。", likes: 58 },
    ],
  },
  {
    id: "15",
    title: "暗房",
    originalTitle: "Darkroom",
    year: 2022,
    genres: ["悬疑", "剧情"],
    rating: 7.7,
    duration: 105,
    director: "崔炳国",
    cast: ["李知恩", "柳承范", "金娜英"],
    region: "韩国",
    collection: ["hot"],
    synopsis:
      "一间只接私人委托的暗房，冲洗的胶卷里出现了不属于拍摄现场的影子。老板起初以为是曝光失误，直到同一个影子出现在三卷不同的胶片上。",
    analysis: [
      "影片最大的看点是对暗房工艺的细致呈现：显影、定影、晾干，每一步都拍得很慢、很实。这种近乎纪录片的质感，让超自然的元素反而更有说服力。",
      "红色安全灯是全片唯一的光源基调，导演把这种限制变成了风格。观众和主角一样，只能在红光下辨认世界。",
      "故事在第三幕转向了对「拍摄者」的追问，立意不错，但解释得稍微多了一点，留白如果再多一些会更好。",
    ],
    tags: ["暗房", "胶卷", "影子", "红光"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20darkroom%20film%20poster%20artwork%2C%20hands%20holding%20a%20wet%20photographic%20print%20above%20developing%20trays%2C%20bathed%20in%20deep%20red%20safelight%2C%20hanging%20film%20strips%20in%20shadow%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20mysterious%20intimate%20mood%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-15&orientation=portrait",
    views: 118900,
    comments: [
      { id: "15-1", user: "显影液", date: "2025-03-05", text: "工艺细节拍得太认真了，光这一点就值得看。", likes: 69 },
      { id: "15-2", user: "红光", date: "2024-12-11", text: "解释稍多，但氛围真的顶。", likes: 44 },
    ],
  },
  {
    id: "16",
    title: "初雪之后",
    originalTitle: "After the First Snow",
    year: 2024,
    genres: ["爱情", "剧情"],
    rating: 8.5,
    duration: 111,
    director: "朴贤宇",
    cast: ["金智秀", "朴道允", "文彩媛"],
    region: "韩国",
    collection: ["new", "hot"],
    synopsis:
      "初雪那天的清晨，一条安静的街道上，两个人朝相反的方向走。影片从这一天开始，倒着讲回他们相识的那个春天。每一段都在回答同一个问题：他们究竟在哪一步走散的。",
    analysis: [
      "倒叙结构用得极其干净，每一段的时间标记都不刻意，观众需要靠季节和衣着自己判断。这种叙事上的自信，在同年的作品里很少见。",
      "影片对「走散」的理解很成熟：不是背叛，也不是误会，而是两个人在同一段时间里，朝着不同的方向长大了一点点。这个主题被拍得非常克制。",
      "摄影是加分项，冬夏两季的色彩对比极大，但整体色调始终统一在暖调里。结尾回到初雪的那个镜头，是本年度最好的收尾之一。",
    ],
    tags: ["新片", "倒叙", "初雪", "四季"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20melancholic%20film%20poster%20artwork%2C%20two%20figures%20walking%20away%20from%20each%20other%20on%20an%20empty%20snow-covered%20Seoul%20street%20at%20dawn%2C%20warm%20amber%20streetlight%20against%20deep%20crimson%20shadows%2C%20falling%20snow%2C%20fine%20film%20grain%2C%20painterly%20photographic%20texture%2C%20quiet%20emotional%20mood%2C%20no%20text%2C%20no%20lettering&width=600&height=900&seq=krfilm-poster-16&orientation=portrait",
    views: 189500,
    comments: [
      { id: "16-1", user: "初雪那天", date: "2025-06-30", text: "倒着讲还能讲得这么清楚，导演真的很有底气。", likes: 141 },
      { id: "16-2", user: "四季", date: "2025-05-15", text: "不是不爱了，是各自长大了一点点。这句话我记很久。", likes: 118 },
      { id: "16-3", user: "雪停之后", date: "2025-03-22", text: "摄影太漂亮了，冬天和夏天像两部电影。", likes: 86 },
    ],
  },
];

export const getMovieById = (id: string | undefined): Movie | undefined =>
  movies.find((item) => item.id === id);

export const getRelatedMovies = (movie: Movie, limit = 4): Movie[] => {
  const sameGenre = movies.filter(
    (item) => item.id !== movie.id && item.genres.some((g) => movie.genres.includes(g)),
  );
  const rest = movies.filter(
    (item) => item.id !== movie.id && !sameGenre.some((s) => s.id === item.id),
  );
  return [...sameGenre, ...rest].sort((a, b) => b.views - a.views).slice(0, limit);
};